angular.module('invoice')
    .component('invoiceProjectBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/invoice/invoice-project/_btn-options.html',
        controller: function (InvoiceProjectService, Principal) {
            this.InvoiceProjectService = InvoiceProjectService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(["ROLE_INVOICE_SETTINGS_WRITE", "ROLE_ADMIN"]);
            }

        }
    })
